const PolicyTermApp = () => {
    return (
        <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
            <h1 style={{ textAlign: "center" }}>
                Polityka Prywatności – Checkardi (Aplikacja Mobilna)
            </h1>

            <p>
                Niniejsza Polityka Prywatności dotyczy aplikacji mobilnej Checkardi
                dostępnej na urządzenia mobilne i jest zgodna z wymaganiami Google Play.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 1 Administrator danych</h2>
            <p><strong>Natalia Jagiełło</strong></p>
            <p>
                E-mail:{" "}
                <a href="mailto:jagiello.nat@gmail.com">jagiello.nat@gmail.com</a>
            </p>

            <h2 style={{ textAlign: "center" }}>§ 2 Zakres danych</h2>
            <ul>
                <li>imię lub nazwa użytkownika</li>
                <li>adres e-mail</li>
                <li>dane konta Google (Google Sign-In)</li>
                <li>opinie i recenzje</li>
                <li>zdjęcia dodawane przez użytkownika</li>
                <li>dane techniczne urządzenia</li>
            </ul>

            <h2 style={{ textAlign: "center" }}>§ 3 Logowanie przez Google</h2>
            <p>
                Aplikacja umożliwia logowanie za pomocą konta Google. Dane te są
                wykorzystywane wyłącznie w celu uwierzytelnienia użytkownika oraz
                synchronizacji z aplikacją webową.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 4 Zdjęcia i moderacja</h2>
            <p>
                Zdjęcia dodawane w aplikacji mogą być weryfikowane w celu zapobiegania
                publikacji treści niezgodnych z regulaminem.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 5 Cele przetwarzania</h2>
            <ul>
                <li>działanie aplikacji</li>
                <li>obsługa kont użytkowników</li>
                <li>zapewnienie bezpieczeństwa</li>
            </ul>

            <h2 style={{ textAlign: "center" }}>§ 6 Udostępnianie danych</h2>
            <ul>
                <li>dostawcy usług IT i hostingu</li>
                <li>Google LLC – w zakresie logowania</li>
            </ul>
            <p>Dane nie są sprzedawane ani wykorzystywane reklamowo.</p>

            <h2 style={{ textAlign: "center" }}>§ 7 Prawa użytkownika</h2>
            <ul>
                <li>dostępu do danych</li>
                <li>usunięcia konta</li>
                <li>cofnięcia zgody</li>
                <li>złożenia skargi do UODO</li>
            </ul>

            <h2 style={{ textAlign: "center" }}>§ 8 Bezpieczeństwo</h2>
            <p>
                Aplikacja stosuje szyfrowanie danych oraz zabezpieczenia systemowe
                platform mobilnych.
            </p>

            <h2 style={{ textAlign: "center" }}>§ 9 Zmiany polityki</h2>
            <p>
                Polityka Prywatności może ulec zmianie. Aktualna wersja jest dostępna
                pod adresem wskazanym w Google Play.
            </p>
        </div>
    );
};

export default PolicyTermApp;
